import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 80,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textMessage: {
    marginTop: -100,
    padding: '0 24px',
    fontWeight: 500,
    fontSize: 32,
    textAlign: 'center',
    color: theme.colors.light.lightCyan,
  },
  buttonGroup: {
    width: '100%',
    marginTop: 40,
    padding: '0 24px',
  },
  buttonSeparator: {
    margin: '0 0 16px 0',
    fontSize: theme.fonts.sizes.font12PX,
    textTransform: 'uppercase',
    fontWeight: 700,
    textAlign: 'center',
    color: theme.colors.light.lightSteelBlue,
    position: 'relative',
    '&:before, &:after': {
      content: '""',
      display: 'block',
      width: '45%',
      height: 1,
      backgroundColor: theme.colors.light.lightSteelBlue,
      position: 'absolute',
      top: '50%',
      zIndex: 1,
      transform: 'translateY(-50%)',
    },

    '&:before': {
      left: 0,
    },

    '&:after': {
      right: 0,
    },
  },
  OrderBottomContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    padding: '15px 15px',
    borderRadius: '18px',
    border: '2px solid #43566C',
    bottom: 30,
    backgroundColor: theme.colors.dark.darkSlateBlue,
    width: '90%',
    height: 80,
  },
  subContainer: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'space-between',
    height: 46,
    background: '#232838',
    border: '1px solid #303C50',
    borderRadius: 10,
    padding: '5px 2rem',
  },
  Price: {
    color: theme.colors.light.freshPowder,
    fontSize: theme.fonts.sizes.font18PX,
    fontWeight: 'bold',
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    height: 46,
    width: '100%',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.steelBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));

export const useStylesBackButton = makeStyles(theme => ({
  root: {
    width: 110,
    height: 46,
    backgroundColor: theme.colors.dark.steelBlue,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));
